<template>
  <div class="my-result">
    <div class="icon">
      <check-circle-two-tone two-tone-color="#52c41a" />
    </div>
    <div class="title">{{ title }}</div>
    <div class="sub-title">{{ subTitle }}</div>
    <div class="sub-title">{{ subTitle1 }}</div>
    <div class="extra">
      <slot name="extra"></slot>
    </div>
  </div>
</template>

<script>
import { ref, onMounted ,computed} from 'vue';
import {  CheckCircleTwoTone } from '@ant-design/icons-vue';

export default {
  name: 'MyResult',
   components: {
 
    CheckCircleTwoTone,
  },
  props: {
    icon: {
      type: String,
      default: 'success'
    },
    title: {
      type: String,
      default: '注册成功'
    },
    subTitle: {
      type: String,
      default: '请复制网址到PC端登录使用，开启轻松备考之旅!'
    },
    subTitle1: {
      type: String,
      default: ''
    }
  },
  setup(props) {
    const subTitle1 = ref(props.subTitle1);

    onMounted(() => {
      const fullUrl = window.location.href;
      const domain = fullUrl.split("#")[0];
      subTitle1.value = domain + "#/login";
    });

    const iconClass = computed(() => `el-icon-${props.icon}`);

    return {
      subTitle1,
      iconClass
    };
  }
};
</script>

<style scoped>
.my-result {
  text-align: center;
  padding: 40px;
}
.icon {
  font-size: 48px;
  color: #67C23A;
  margin-bottom: 20px;
}
.title {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 10px;
}
.sub-title {
  font-size: 14px;
  color: #999;
  margin-bottom: 20px;
}
.extra {
  margin-top: 20px;
}
</style>